document.addEventListener('DOMContentLoaded', () => {
 
  const videos = Array.from(document.querySelectorAll('video.shopify-lazy-video'));  
  // Step A: Disarm sources (move src -> data-src so nothing loads yet)
  videos.forEach(video => {
    // If <video> has a direct src, move it
    if (video.hasAttribute('src')) {
      video.dataset.src = video.getAttribute('src');
      video.removeAttribute('src');
    }
    // Move each <source src> to data-src
    video.querySelectorAll('source').forEach(source => {
      if (source.getAttribute('src')) {
        source.dataset.src = source.getAttribute('src');
        source.removeAttribute('src');
      }
    });
    // Reset the resource selection so nothing is fetched
    video.load();
  });


  // Step B: Observe and load on enter
  const loadVideo = (video) => {
    const sources = video.querySelectorAll('source[data-src]');
    if (sources.length) {
      sources.forEach(s => {
        s.setAttribute('src', s.dataset.src);
        s.removeAttribute('data-src');
      });
    } else if (video.dataset.src) {
      // Fallback if <video> had a direct src
      video.setAttribute('src', video.dataset.src);
      delete video.dataset.src;
    }
    video.load();

    // Optional auto-play when visible and allowed (muted + playsinline recommended)
    if (video.hasAttribute('autoplay') || video.dataset.autoplay === 'true') {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {/* ignore autoplay errors */});
      }
    }
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {                
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' }); // pre-load a bit before it’s visible

    videos.forEach(v => io.observe(v));
  } else {
    // Fallback: just load immediately
    videos.forEach(loadVideo);
  }
});